import client from '@/apis/http-backbone.js'
import axios from 'axios'

export const actions = {
  async setShopId ({commit}, shopId) {
    try {
      // console.log('storeShop', shopId)
      commit('SET_SHOPID', shopId)
      return
    } catch (error) {
      console.error('setShopId error', error.message)
      return null
    }
  },
  async getShopTheme ({commit, state}) {
    try {
      const response = await client.apiLoyalty('get', 'color/line/get?RECORD_STATUS=N&from=store')
      if (response.data.status) {
        commit('SET_THEME', null)
      } else {
        commit('SET_THEME', response.data[0])
      }
      return
    } catch (error) {
      console.error('getTheme error', error.message)
      commit('SET_THEME', null)
      return null
    }
  },
  async getBlog ({commit, state}) {
    try {
      const response = await client.apiLoyalty('get', `promotion/get?RECORD_STATUS=N&shopId=${state.shopId}`)
      if (response.data.status) {
        commit('SET_BLOG', null)
      } else {
        commit('SET_BLOG', response.data)
      }
      return
    } catch (error) {
      console.error('getBlog error', error.message)
      commit('SET_BLOG', null)
      return null
    }
  },
  async getShoppLevel ({commit, state, rootGetters}) {
    try {
      const shopId = rootGetters['shopStore/GET_SHOPID']
      const profile = rootGetters['lineStore/getLiffProfile']
      const result = await axios.get('https://api-beloyalty-productions.betaskthai.tech/level/line/get?RECORD_STATUS=N', { headers: {lineUserId: profile.userId, lineId: profile.userId, shopId: shopId} })
      if (result.data.length > 0) {
        // this.level = result.data[0]
        commit('SET_LEVEL', result.data)
      }
      return
    } catch (error) {
      console.error('getMemberProfile error', error.message)
      return null
    }
  },
  async getShopById ({ commit }, shopId) {
    try {
      const response = await client.apiLoyalty('get', `shop/get?shopId=${shopId}`)
      if (response.data && response.data.status !== true) {
        commit('SET_SHOPINFO', response.data)
        return response.data
      } else {
        commit('SET_SHOPINFO', null)
        return null
      }
    } catch (error) {
      console.error('getShopById error', error.message)
      commit('SET_SHOPINFO', null)
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/shop/actions.js